import { getAIHook } from '@openclassrooms/data-connect-web/utils';

const useEnhanceAbout = getAIHook({
  promptCode: 'enhance-about',
  serverName: 'ai-api-user',
});

export default useEnhanceAbout;
